import { FormikValues, getIn, useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { AddressVerificationCard } from './AddressVerificationCard';
import { useVenueAddressVerificationContext } from './VenueAddressVerificationContext';

export function useVenueAddressState(name: string): {
  verifiedAddress: string;
  setVerifiedAddress: (address: string) => void;
} {
  const { initialValues, touched } = useFormikContext<FormikValues>();
  const addressPath = `${name}.address`;

  const [verifiedAddress, setVerifiedAddress] = useState<string>(
    () => (getIn(initialValues, addressPath) as string) || '',
  );

  const isAddressTouched = !!getIn(touched, addressPath);
  useEffect(() => {
    if (!isAddressTouched) {
      setVerifiedAddress((getIn(initialValues, addressPath) as string) || '');
    }
  }, [initialValues, addressPath, isAddressTouched]);

  return { verifiedAddress, setVerifiedAddress };
}

export function FormikVenueAddressSuggestion() {
  const { isPending, topSuggestion, applySuggestion, dismissSuggestion } =
    useVenueAddressVerificationContext();

  if (!isPending || !topSuggestion) return null;

  return (
    <AddressVerificationCard
      suggestion={topSuggestion}
      onAccept={() => applySuggestion(topSuggestion)}
      onDismiss={dismissSuggestion}
    />
  );
}
